/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SortingDirection = {
    Descending: -1,
    Ascending: 1
} as const;
export type SortingDirection = typeof SortingDirection[keyof typeof SortingDirection];

